var layoutStyles = {
    divider: function (theme) {
        var _a;
        return (_a = {
                marginBottom: theme.spacing(3.75)
            },
            _a[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _a);
    },
    searchFiltersContainer: function (theme) { return ({
        backgroundColor: theme.palette.background.default,
        textAlign: 'left',
        '@media (max-width: 930px)': {
            padding: theme.spacing(0, 2),
        },
    }); },
};
export var mainLayoutStyles = {
    searchBarContainer: function (theme) {
        var _a;
        return (_a = {
                margin: 'auto',
                padding: theme.spacing(6.875, 3.75, 0)
            },
            _a[theme.breakpoints.down('md')] = {
                padding: theme.spacing(0, 1.875),
            },
            _a[theme.breakpoints.up('md')] = {
                padding: theme.spacing(0, 2),
            },
            _a[theme.breakpoints.up('lg')] = {
                padding: theme.spacing(0),
            },
            _a);
    },
    searchBar: function (theme) {
        var _a;
        return (_a = {},
            _a[theme.breakpoints.up('md')] = {
                borderBottom: "1px solid ".concat(theme.palette.secondary.contrastText),
                maxWidth: 1104,
                margin: '0 auto',
            },
            _a);
    },
    toggleButton: function (theme) {
        var _a;
        return (_a = {
                position: 'fixed',
                right: 0,
                top: '50%',
                marginTop: theme.spacing(-3),
                minWidth: 0,
                width: theme.spacing(6.25),
                fontSize: theme.spacing(2),
                fontWeight: 'bold',
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.background.default,
                display: 'block',
                padding: theme.spacing(1.25, 0),
                borderRadius: theme.spacing(0.5, 0, 0, 0.5),
                lineHeight: '22px',
                '&:hover': {
                    backgroundColor: theme.palette.primary.contrastText,
                }
            },
            _a[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _a.span = {
                margin: 0,
                marginTop: theme.spacing(1.25),
            },
            _a);
    },
    toggleButtonIcon: function (theme) { return ({
        '& .MuiButton-endIcon': {
            marginRight: 0,
            marginLeft: 0,
            marginTop: theme.spacing(1.25),
        },
    }); },
    fullWidthContent: function (theme) {
        var _a;
        return (_a = {
                width: '100%'
            },
            _a[theme.breakpoints.up('sm')] = {
                marginTop: '0 !important',
            },
            _a);
    },
};
export default layoutStyles;
